const PROXIMONUMERO_SOBRE = { proximoNumeroSobre: 1402 };

const getProximoNumeroSobre = async () => {
  return PROXIMONUMERO_SOBRE;
};

const proximoNumeroSobre = {
  getProximoNumeroSobre,
};

export default proximoNumeroSobre;
